<template>
  <div class="btn-group w-100 mb-2" role="group">
    <button
      class="btn btn-sm btn-outline-dark overflow-ellipsis quizButton"
      @click="playClick"
    >
      <span class="quizName mr-2">{{ quiz.name }}</span>
      <HostBadge v-bind:hostName="quiz.host" class="mr-2" />
    </button>
    <button
      class="btn btn-sm btn-outline-dark overflow-ellipsis spectateButton"
      @click="spectateClick"
    >
      <b-icon-eye-fill />
    </button>
  </div>
</template>

<script>
import HostBadge from "@/components/HostBadge";

export default {
  name: "QuizItem",
  props: ["quiz"],
  components: {
    HostBadge
  },
  methods: {
    spectateClick() {
      this.$router.push("/spectate/" + this.quiz.spectate_code);
    },
    playClick() {
      this.$emit("join-requested", this.quiz.id);
    }
  }
};
</script>

<style scoped>
.spectateButton {
  width: 50px;
  flex-grow: 0 !important;
}
</style>
